import { APPLICATION_FILTERS_SLICE_NAME } from "./applicationFilters.actions";
import { applicationFiltersReducer } from "./applicationFilters.reducer";
import { applicationFiltersSaga } from "./applicationFilters.saga";
export var applicationFiltersModule = {
    sliceName: APPLICATION_FILTERS_SLICE_NAME,
    reducer: applicationFiltersReducer,
    reducerState: {},
    saga: applicationFiltersSaga,
};
